'use strict';

// Based on:
// http://jsbin.com/oxaxuc/13/edit?js

if (!Element.prototype.scrollIntoViewIfNeeded) {
  Element.prototype.scrollIntoViewIfNeeded = function (centered) {
    centered = centered === undefined? true: !!centered;
    
    // The following are always from the {top, bottom, left, right}
    // of the viewport, to the {top, …} of the box.
    // Think of them as geometrical vectors, it helps.
    // The axes are directed downwards and towards the right.
    
    var topToBottom = this.offsetTop + this.offsetHeight - window.scrollY,
        bottomToTop = - window.innerHeight + topToBottom - this.offsetHeight,
        leftToRight = this.offsetLeft + this.offsetWidth,
        rightToLeft = - window.innerWidth + leftToRight - this.offsetWidth,
        xAllowed = true,  // We allow one translation on the x axis,
        yAllowed = true;  // and one on the y axis.
    
    // Whatever `centered` is, the behavior is the same if the box is
    // (even partially) visible.
    
    if ((topToBottom > 0 || !centered) && topToBottom <= this.offsetHeight) {
      if (yAllowed) {
        scrollBy(0, topToBottom - this.offsetHeight);
        yAllowed = false;
      }
    } else 
    if ((bottomToTop < 0 || !centered) && bottomToTop >= -this.offsetHeight) {
      if (yAllowed) {
        scrollBy(0, bottomToTop + this.offsetHeight);
        yAllowed = false;
      }
    }
    
    if ((leftToRight > 0 || !centered) && leftToRight <= this.offsetWidth) {
      if (xAllowed) {
        scrollBy(leftToRight - this.offsetWidth, 0);
        xAllowed = false;
      }
    } else 
    if ((rightToLeft < 0 || !centered) && rightToLeft >= -this.offsetWidth) {
      if (xAllowed) {
        scrollBy(rightToLeft + this.offsetWidth, 0);
        xAllowed = false;
      }
    }
    
    // If we want it centered, and the box is completely hidden,
    // then we center it explicitly.
    
    if (centered) {
      if (yAllowed && (topToBottom <= 0 || bottomToTop >= 0)) {
        scroll(window.scrollX, this.offsetTop + this.offsetHeight / 2 - window.innerHeight / 2);
      }
    
      if (xAllowed && (leftToRight <= 0 || rightToLeft <= 0)) {
        scroll(this.offsetLeft + this.offsetWidth / 2 - window.innerWidth / 2, window.scrollY);
      }
    }
  };
}


/** WEBPACK FOOTER **
 ** ./utils/polyfills/ScrollIntoViewIfNeededPolyfill.js
 **/